import { Link } from 'react-router-dom';
import styles from './NavBar.module.css';

export default function NavBar({ cartOpen, itemCount = 0, navItems, navLogo, openCart }) {
  return (
    <nav className={styles.siteNav}>
      <div className={`${styles.navCell} ${styles.navLeft}`}>Rochester, New York</div>
      <Link className={`${styles.navCell} ${styles.navCenter} ${styles.navLogoLink}`} to="/home#top" aria-label="M80 home">
        <img src={navLogo} alt="M80" className={styles.navLogo} />
      </Link>
      <div className={`${styles.navCell} ${styles.navRight}`}>
        {navItems.map((item) => {
          const isCartItem = item.name === 'Cart';

          return (
            <Link
              to={item.path}
              key={item.name}
            >
              {isCartItem ? (
                <span className={styles.cartLink}>
                  <span>Cart</span>
                  {itemCount > 0 && (
                    <span className={styles.cartTriggerCount}>{itemCount}</span>
                  )}
                </span>
              ) : (
                item.name
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}